<!-- eslint-disable vue-i18n/no-missing-keys -->
<template>
  <div>
    <v-skeleton-loader v-if="loading" />
    <v-row
      align="center"
      justify="center"
      class="d-flex-column"
    >
      <v-col
        md="4"
        cols="12"
      >
        <v-menu
          ref="menu"
          v-model="isMenuOpen"
          :closeOnContentClick="false"
          transition="scale-transition"
          offsetY
          minWidth="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeText"
              :label="$t('generic.dateRange')"
              prependInnerIcon="event"
              readonly
              outlined
              :hideDetails="true"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dates"
            range
            :max="$utils.getTomorrowDate()"
            :landscape="customLandscape"
            :disabled="loadingCSV"
            :locale="datePickerLocales[$store.getters.lang]"
            color="#26384B"
          />
        </v-menu>
      </v-col>
      <v-col
        md="auto"
        cols="12"
      >
        <VSelect
          v-model="from"
          outlined
          :label="$t('exportAnalysis.type')"
          :hideDetails="true"
          :items="dataTypes"
          :itemText="item => $t(item.text)"
        />
      </v-col>
      <v-col
        md="auto"
        cols="12"
      >
        <v-btn
          style="background-color: #EF4135; color: white; text-transform: capitalize"
          :disabled="disableBtn"
          @click="exportSiteAnalysisCSV"
        >
          {{ $t('exportAnalysis.export') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _datePickerLocales from '@/locales/date-picker-locales';

export default {
    components: {
    },
    props: {
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dates: [],
            isMenuOpen: false,
            loadingCSV: false,
            loading: true,
            from: '',
            dataTypes: [
                {
                    text: 'administration.users',
                    value: 'user',
                },
                {
                    text: 'sitePage.devices',
                    value: 'controller',
                },
            ],
            client: { ...this.$store.getters.client },
            site: { ...this.$store.getters.site },
            siteTree: [],
            componentsPerId: {},
            analysisTypesPerId: {},
            uniqueLinesComponents: [],
            customLandscape: false,
        };
    },
    computed: {
        dateRangeText() {
            return this.dates
                .map(date => this.$options.filters.formatDate(date, 'L'))
                .join(' ~ ');
        },
        exportAnalysisTitle() {
            return `${this.site.name} - ${this.client.name}`;
        },
        disableBtn() {
            return !!(this.dates.length < 2);
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    mounted() {
        this.updateCustomLandscape();
        window.addEventListener('resize', this.updateCustomLandscape);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateCustomLandscape);
    },
    async created() {
        const { siteId } = this.$route.params;
        if (siteId) {
            const response = await this.$rq.getSiteTree(siteId);
            // get tree of site
            this.siteTree = response.data.tree;
            await this.getComponentsFromTree(this.siteTree);
            await this.getAnalysisTypesPerId();
        }
        this.loading = false;
    },
    methods: {
        async getAnalysisTypesPerId() {
            const { data } = await this.$rq.getAnalysisTypes({ typeName: 'All', pagination: false });
            this.analysisTypesPerId = data.reduce((map, analysisType) => ({
                ...map,
                [analysisType.id]: analysisType,
            }), {});
        },
        async exportSiteAnalysisCSV() {
            this.loadingCSV = true;
            const startDate = new Date(this.dates[0]).toISOString();
            const endDate = this.dates[1] ? new Date(this.dates[1]).toISOString() : (new Date()).toISOString();
            const payload = {
                startDate,
                endDate,
                from: this.from ? this.from : undefined,
            };
            const response = await this.$rq.exportSiteAnalysisCSV(this.$route.params.siteId, payload);

            if (response.data && !response.data.size) {
                this.$toasted.global.toast_error({
                    message: this.$t('exportAnalysis.noResults'),
                });
            } else {
                const fileName = `exportAnalysis_${this.site.deliveryAccountNumber}_${startDate.split('T')[0]}_to_${endDate.split('T')[0]}.csv`;
                this.$utils.saveFileOnDisk(new Blob([response.data]), fileName);
            }

            this.loadingCSV = false;
        },
        getComponentsFromTree(node, networkParent) {
            node.forEach(el => {
                let networkNode = { networkParentName: '', networkParentId: '' };

                if (el.nodeType === 'Network') networkNode = { networkParentName: el.name, networkParentId: el.ref };

                if (el.nodeType === 'Component') {
                    this.componentsPerId[el.ref] = { ...el, ...networkParent, ...networkNode };
                } else if (typeof el.children !== 'undefined') this.getComponentsFromTree(el.children, networkNode);
            });
        },
        updateCustomLandscape() {
            this.customLandscape = window.innerWidth > 600;
        },
    },
};
</script>
<style scoped>
    .v-menu__content {
        margin-top: 5px !important;
    }
</style>
